import { useState } from "react";
import fetchService from "../lib/fetchService";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFeedback, setLoginFeedback] = useState('');
  return (
    <>
      <div className="flex flex-center">
        <div className="w3-card w3-white">
          <h1 className="w3-margin">Login</h1>
          <div className="w3-margin">
            <input
              className="w3-input"
              type="email"
              placeholder="email"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="w3-margin">
            <input
              className="w3-input"
              type="password"
              placeholder="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {loginFeedback && <div className="w3-margin w3-red w3-padding">{loginFeedback}</div>}
          <div className="w3-margin">
            <button
              className="w3-button w3-green"
              onClick={async () => {
                const feedback = await fetchService.login(username, password);
                setLoginFeedback(feedback);
                if (feedback === '') {
                  navigate('/');
                }
              }}
            >Login</button>
          </div>

        </div>
      </div>
      <div className="flex flex-center">
        <p>Der Demo Login ist: john@doe.com und formel1</p>

      </div>
    </>
  );
}